import { darken, lighten } from "polished";
import defaultsDeep from "lodash/defaultsDeep";
import { black } from "../colors";
import * as steelGrey from "../colors/steelGrey";
import * as deepBlue from "../colors/deepBlue";
import * as red from "../colors/red";
import * as aqua from "../colors/aqua";
import * as blue from "../colors/blue";
import * as cyan from "../colors/cyan";
import * as teal from "../colors/teal";
import * as purple from "../colors/purple";
import { alchemyPanel } from "./alchemy-panel";
export const alchemyPanelContrast = defaultsDeep({
    structural: {
        base: steelGrey.steelGrey700,
        typeHeader: black,
        typeSubHeader: steelGrey.steelGrey700,
        typeBody: black,
        typeMeta: "#656F81",
        typeLink: "#293BE0",
        contrast: black,
        highlight: steelGrey.steelGrey200,
        brandPrimary: "#3F44CA",
        brandSecondary: "#121826"
    },
    // Interactive
    interactiveNavigational: {
        base: lighten(0.015, steelGrey.steelGrey700),
        contrast: steelGrey.steelGrey800
    },
    interactiveConstructive: {
        base: lighten(0.02, deepBlue.deepBlue700),
        contrast: deepBlue.deepBlue900
    },
    interactiveDestructive: {
        base: red.red900,
        contrast: red.red1000
    },
    // Visualization colors
    visualizationOne: {
        inverseContainer: darken(0.02, purple.purple700)
    },
    visualizationThree: {
        inverseContainer: darken(0.085, aqua.aqua1000)
    },
    visualizationFour: {
        inverseContainer: darken(0.07, blue.blue700)
    },
    visualizationFive: {
        inverseContainer: darken(0.07, cyan.cyan800)
    },
    visualizationSix: {
        inverseContainer: darken(0.087, teal.teal900)
    }
}, alchemyPanel);
